module.exports = __webpack_public_path__ + "static/media/logo_en.ba8bc5a1.svg";